;(() => {
  'use strict'

  const ComingSoon = class extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.logoContainer.addEventListener('click', () => this.showPopin())
      this.popinWrapper.addEventListener('click', (event) => {
        if (event.target === this.popinWrapper) {
          this.hidePopin()
        }
      })
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('data-popin-open')) {
          this.hidePopin()
        }
      })
    }

    get popinWrapper() {
      return this.querySelector('.popin-wrapper')
    }

    get logoContainer() {
      return this.querySelector('.diptyque-logo')
    }

    get passwordInput() {
      return this.popinWrapper?.querySelector('input[type="password"]')
    }

    showPopin = () => {
      this.lastFocusedElement = document.activeElement
      this.setAttribute('data-popin-open', '')
      // Déplacer le focus vers le champ mot de passe à l'ouverture.
      this.passwordInput?.focus()
    }

    hidePopin = () => {
      this.removeAttribute('data-popin-open')
      // Restaurer le focus sur le déclencheur (logo).
      if (this.lastFocusedElement && this.lastFocusedElement.focus) {
        this.lastFocusedElement.focus()
      }
    }
  }
  if (!window.customElements.get('coming-soon')) {
    window.customElements.define('coming-soon', ComingSoon)
  }
})()
